import { useMemo } from 'react';

import type {
  IBccDescription,
  TBccAlternativeOffer,
  TBccBankOffer
} from '@/components/App/NewOrder/offer-step/types/bcc.types';
import { BccBankStatus } from '@/components/Shared/constants/banks-statuses';
import { BCC_PRODUCTS } from '@/constants';
import { handleError } from '@/services/handleError';

import { getBaseAdditionalProducts } from '../../../helpers/getBaseAdditionalProducts';

interface IProps {
  bankOffer: TBccBankOffer;
}

const useAlternatives = ({ bankOffer }: IProps) => {
  const alternatives: TBccAlternativeOffer[] = useMemo(() => {
    if (bankOffer.alternatives && bankOffer.alternatives.length > 0)
      return bankOffer.alternatives;

    const bankDescription = bankOffer.bankDescription;
    const statusCode = bankOffer.status.code;
    const isPreApproved: boolean =
      statusCode === BccBankStatus.PreApproved ||
      statusCode === BccBankStatus.ClientAccepted;

    if (!bankDescription || !isPreApproved) return [];

    try {
      const bccResponse: IBccDescription = JSON.parse(bankDescription);

      const additionalPND = bccResponse.additionalPND;

      if (additionalPND && additionalPND.length > 0) {
        return additionalPND.map(
          (item) =>
            ({
              additionalProducts: getBaseAdditionalProducts(item),
              description: { additionalPND },
              extUuid: item.code || bankOffer.status.code, // Используется для отправки в банки
              initialPayment: String(item.down_payment),
              insuranceAmount: item.insurance_amount,
              insuranceName: item.insurance_name,
              insuranceTerm: item.insurance_term,
              loanAmount: String(item.loan_amount),
              loanPeriod: String(item.term),
              monthlyPayment: String(item.monthly_payment),
              product: BCC_PRODUCTS[item.code],
              rate: item.interest_rate,
              responseUuid: bankOffer.id,
              uuid: bankOffer.id + item.code // Внутренний uuid
            }) satisfies TBccAlternativeOffer
        );
      }
    } catch (error) {
      handleError(error, { notify: false });
      return [];
    }

    return [];
  }, [bankOffer]);

  return alternatives;
};

export default useAlternatives;
